import { render, staticRenderFns } from "./PaginationPanelThan.vue?vue&type=template&id=71f662e9&scoped=true"
import script from "./PaginationPanelThan.vue?vue&type=script&lang=ts"
export * from "./PaginationPanelThan.vue?vue&type=script&lang=ts"
import style0 from "./PaginationPanelThan.vue?vue&type=style&index=0&id=71f662e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f662e9",
  null
  
)

export default component.exports